var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"supply-chain container-fluid py-3"},[_c('router-view',{on:{"childrenRoute":_vm.hideNonChildren}}),(_vm.hasPageChild==0)?_c('div',{staticClass:"row"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }